module.exports = __webpack_public_path__ + "img/mobile/BetBar/Home_button@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/Home_button@3x.png
// module id = 595
// module chunks = 0